import * as types from "../../actions/companylevel/index";
export default function(state = [], action) {
  switch (action.type) {
    case types.FETCH_REPORTED_WAGES_LIST:
      return action.payload.data;

    default:
      return state;
  }
}
